import { render, staticRenderFns } from "./vs-form-select.vue?vue&type=template&id=6fecdaf0&scoped=true"
import script from "./vs-form-select.vue?vue&type=script&lang=js"
export * from "./vs-form-select.vue?vue&type=script&lang=js"
import style0 from "./vs-form-select.vue?vue&type=style&index=0&id=6fecdaf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fecdaf0",
  null
  
)

export default component.exports